export default __webpack_public_path__ + "img/g100.c3aca75c.png";